import { Toast } from 'vant'

/**
 * loading
 * @param {string} [message] 文案
 * @return {{clear: function}}
 */
export function $loading (message = '加载中...') {
  return Toast.loading({
    message,
    forbidClick: true
  })
}

export function $success (message = '成功') {
  return Toast.success({
    message,
    forbidClick: true
  })
}
